import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Context } from '../../../context/UserContext';

import { useLocation } from 'react-router-dom';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider, useMediaQuery } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

//Import Material React Table Translations
import { useMRTState } from '../../../hooks/useMRTState';
import { getMRTDefaultProps } from '../../../helpers/mrt/getMRTDefaultProps';
import CustomDialog from '../../layout/CustomDialog';

import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import CRUDsAPI from '../../../api/CRUDs';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

/* util */
import { obterPermissoesUsuario } from '../../../utils/funcoes';

const Index = () => {
    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem('token')) || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search || location.state);

    const pathname = '/Permissoes/CreateOrEdit';
    const ul = urlParams.get('ul') || 1;
    const li = urlParams.get('li') || 10;
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    const { parametro } = useContext(Context);
    const mrt = useMRTState({ storageKey: 'permissoes.lista', pageSizeDefault: parametro?.paginacao || 10 });
    const {
        columnFilterFns,
        columnFilters,
        globalFilter,
        sorting,
        pagination,
        isError,
        setIsError,
        setIsLoading,
        setIsRefetching,
        setRowCount,
    } = mrt;
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const fetchData = async () => {
        if (!dados.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        setIsError(false);

        try {
            const response = await CRUDsAPI.permissoes.listar(
                pagination.pageIndex * pagination.pageSize,
                pagination.pageSize,
                JSON.stringify(columnFilters ?? []),
                JSON.stringify(columnFilterFns ?? []),
                globalFilter ?? '',
                JSON.stringify(sorting ?? [])
            );

            setDados(response.data.data ?? []);
            setRowCount(response.data.meta?.totalRowCount ?? 0);
        } catch (error) {
            setIsError(true);
            setDados([]);
            setRowCount(0);

            setFlashMessage(error.response?.data?.message || 'Não foi possível consultar as permissões.', 'error');
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    };

    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async (row) => {
        // Verifique se há uma linha selecionada
        let msgType = 'success';
        if (selectedRow) {
            try {
                const response = await CRUDsAPI.permissoes.deletar(selectedRow);

                setFlashMessage(response.data.message, msgType);

                // Após a exclusão, chame a função fetchData() novamente para atualizar as unidades
                fetchData();
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response?.data?.message || 'Não foi possível excluir a permissão.', msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //permissões do usuario
        obterPermissoesUsuario(localStorage.getItem('pessoaId'), localStorage.getItem('empresaId'), ul, li);

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, ul, li]);

    const columns = useMemo(
        () => [
            {
                id: 'id',
                header: 'Permissões de usuários do sistema',
                columns: [
                    {
                        accessorKey: 'Empresa.cnpj',
                        header: 'Empresa',
                    },
                    {
                        accessorKey: 'Pessoa.descricao',
                        header: 'Nome',
                    },
                    {
                        accessorKey: 'Pessoa.pessoaUsuario.usuario',
                        header: 'Usuário',
                    },
                    {
                        accessorKey: 'Menu.descricao',
                        header: 'Menus',
                        //you can access a cell in many callback column definition options like this
                        muiTableBodyCellProps: ({ cell }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'menuSub.descricao',
                        header: 'Sub-Menus',
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },
        ],
        []
    );

    /* modo tema */
    const theme = tableThemeCustom();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const mrtDefault = getMRTDefaultProps({ mrt, parametro, isMobile });

    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title="Delete PERMISSÃO!"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    {...mrtDefault}
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 0.5 }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    {' '}
                                    <IconButton
                                        onClick={() => {
                                            params.set('uuid', row.id);
                                            params.set('btnText', 'Atualizar');
                                            navigate(pathname, params);
                                        }}
                                        disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleOpenDialog(row)}
                                        disabled={localStorage.getItem('cancelar') === 'true' ? false : true}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <div
                            style={{
                                display: 'flex',
                                gap: '8px',
                            }}
                        >
                            <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                <div>
                                    <Button
                                        color="secondary"
                                        onClick={() => {
                                            params.delete('uuid');
                                            params.set('btnText', 'Cadastrar');
                                            navigate(pathname, params);
                                        }}
                                        variant="contained"
                                        disabled={false}
                                    >
                                        Novo
                                    </Button>
                                </div>
                            </Tooltip>
                        </div>
                    )}
                    columns={columns}
                    data={dados}
                    enableRowSelection={false}
                    getRowId={(row) => row.uuid}
                    muiToolbarAlertBannerProps={
                        isError ? { color: 'error', children: 'Não foi possível carregar as permissões.' } : undefined
                    }
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
